import { Box, Fade } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";

interface ClickableOverlayProps {
  label: string;
  children: React.ReactNode;
}

export const ClickableOverlay: React.FC<ClickableOverlayProps> = ({
  label,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const toggle = () => setIsOpen((prev) => !prev);
  const close = () => setIsOpen(false);

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        close();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close on scroll
  useEffect(() => {
    const handleScroll = () => close();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box
      ref={containerRef}
      position="relative"
      display="inline-block"
      onClick={toggle}
      cursor="pointer"
      border="2px solid transparent"
      _hover={{ borderColor: "#4895ef", borderRadius: "25px" }}
    >
      {children}

      <Fade in={isOpen}>
        <Box
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          bg="#4895ef"
          color="white"
          borderRadius="25px"
          p={4}
          maxW="300px"
          textAlign="center"
          zIndex={10}
          pointerEvents="none"
        >
          {label}
        </Box>
      </Fade>
    </Box>
  );
};
